export default __webpack_public_path__ + "static/media/save-icon.692e53fc.svg";